module.exports = __webpack_public_path__ + "img/CineCameraOffsetParam.c89139d0.png";